export default __webpack_public_path__ + "static/media/Inter-MediumItalic.dd1448de.woff2";